
















import { defineComponent } from '@vue/composition-api';
import type { PropType } from '@vue/composition-api';

import useVehicle from '@/useVehicle';
import type { Vehicle } from '@/useVehicle';

const LeasedVehicleObject = defineComponent({
  props: {
    active: { default: false },
    vehicle: {
      type: Object as PropType<Vehicle>,
      default: () => ({
        id: -1,
        model: '',
        color: '',
        vehicleType: '',
      }),
    },
  },
  setup() {
    const { translate } = useVehicle();

    return {
      translate,
    };
  },
});

export default LeasedVehicleObject;
